import { StyleSheet } from 'react-native'

// Styles
export default StyleSheet.create({
  container: {
    position: 'relative'
  }
})